import React, { useMemo } from 'react';

import { useUnit } from 'effector-react';
import { Navigate, Route, Routes as RoutesComponent } from 'react-router-dom';

import { Navigation } from '../../components/Navigation';
import { User$ } from '../../effector/user';
import { checkPermissions, UserAction } from '../../utils/permissions';
import { SecurityInfo } from '../Administration/SecurityInfo';
import { PrivateRoute } from '../PrivateRoute';
import { PAGE_REFERENCES, PAGE_REFERENCES_SECURITIES, PAGE_REFERENCES_STRATEGIES_PARAMS } from '../Routes';
import { StrategiesParams } from '../StrategiesParams';

export const References: React.FC = () => {
  const user = useUnit(User$);

  const navigation = useMemo(() => {
    if (!user) {
      return [];
    }

    const items = [
      {
        name: 'Параметры стратегий',
        path: PAGE_REFERENCES_STRATEGIES_PARAMS,
        action: UserAction.strategyParams,
      },
      {
        name: 'ЦБ',
        path: PAGE_REFERENCES_SECURITIES,
        action: UserAction.strategyParams,
      },
    ];

    return items.filter((item) => checkPermissions(user.role, item.action));
  }, [user]);

  return (
    <div className="administration">
      <div className="administration__navigation">
        <Navigation items={navigation} basePath={PAGE_REFERENCES} />
      </div>
      <div className="administration__content">
        <RoutesComponent>
          <Route
            path={PAGE_REFERENCES_STRATEGIES_PARAMS}
            element={<PrivateRoute userAction={UserAction.strategyParams} component={StrategiesParams} />}
          />
          <Route
            path={PAGE_REFERENCES_SECURITIES}
            element={<PrivateRoute userAction={UserAction.strategyParams} component={SecurityInfo} />}
          />
          <Route
            path="*"
            element={<Navigate replace to={`${PAGE_REFERENCES}/${PAGE_REFERENCES_STRATEGIES_PARAMS}`} />}
          />
        </RoutesComponent>
      </div>
    </div>
  );
};
